import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';

import { ExcelService } from '../../services/excel.service';
import { PedidoConsultaElement } from 'src/app/interfaces/pedido.consulta';

@Component({
  selector: 'app-relatorio-pagamentos',
  templateUrl: './relatorio-pagamentos.component.html',
  styleUrls: ['./relatorio-pagamentos.component.scss', '../../styles/estilo.padrao.scss']
})
export class RelatorioPagamentosComponent implements OnInit {
  uid;
  range: FormGroup;

  maxDate: Date = new Date();
  minDate: Date = new Date();
  today: Date = new Date();

  pedidos = [];

  valorTotalPedidos: number = 0;
  valorTotalPagamentosPendentes: number = 0;


  sBuscaTipoPagamento: string = 'Todos';
  aTiposPagamento: any[] = [
    { value: 'Todos', name: 'Todos' },
    { value: 'Cheque', name: 'Cheque' },
    { value: 'Cartão de crédito', name: 'Cartão de crédito' },
    { value: 'Cartão de débito', name: 'Cartão de débito' },
    { value: 'Dinheiro', name: 'Dinheiro' },
    { value: 'Nota', name: 'Nota' },
    { value: 'Pix', name: 'Pix' },
  ];

  sBuscaStatusPagamento: string = 'Todos';
  aStatusPagamento: any[] = [
    { value: 'Todos', name: 'Todos' },
    { value: 'Pendente', name: 'Pendentes' },
    { value: 'Pago', name: 'Pagos' },
    { value: 'Cancelado', name: 'Cancelados' },
  ];

  tipoCadastro = 'Vendedor';

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private af: AngularFireAuth

  ) {
    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });

    const currentYear = new Date().getFullYear();
    this.minDate = new Date(2021, 0, 1);
  }

  ngOnInit(): void {
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });

    //this.range.get('start').patchValue(new Date(2021, 10, 1));
    this.range.get('start').patchValue(new Date());
    this.range.get('end').patchValue(new Date());
  }

  buscarRelatorioMovimentacaoPeriodo() {
    this.spinner.show('relatorio-pagamentos');
    let timestampInicio: Date = new Date(this.range.get('start').value);
    timestampInicio.setHours(0);
    timestampInicio.setMinutes(0);
    timestampInicio.setSeconds(0);
    timestampInicio.setMilliseconds(0);

    let timestampFinal: Date = new Date(this.range.get('end').value);
    timestampFinal.setHours(23);
    timestampFinal.setMinutes(59);
    timestampFinal.setSeconds(59);
    timestampFinal.setMilliseconds(999);
    let difference = (timestampInicio.getFullYear() * 12 + timestampInicio.getMonth()) - (timestampFinal.getFullYear() * 12 + timestampFinal.getMonth());

    if (difference <= -12) {
      this.toastr.warning('Não é possível realizar um filtro acima de 12 meses!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('relatorio-pagamentos'), 300);
      return;
    }

    this.usuarioService.getPedidosTimestamp(timestampInicio.getTime(), timestampFinal.getTime(), 'Período').pipe(take(1)).subscribe(snap => {

      this.pedidos = [];
      this.valorTotalPedidos = 0;
      this.valorTotalPagamentosPendentes = 0;

      if (snap.length <= 0) {
        this.toastr.info('Nenhum registro encontrado para o período selecionado.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
        this.spinner.hide('relatorio-pagamentos');
        return;
      }

      snap.forEach((item) => {
        const pedidoOriginal: any = item.payload.val() as PedidoConsultaElement;

        if (this.validarFiltro(this.sBuscaTipoPagamento, this.sBuscaStatusPagamento, pedidoOriginal)) {
          const {
            ID,
            IDCidade,
            IDDispositivo,
            IDRota,
            IDUsuario,
            IDUsuario_Timestamp,
            IDVendedor,
            IDVendedor_Timestamp,
            Latitude,
            Longitude,
            Timestamp,
            TimestampVencimento,
            TimestampVencimento2,
            TimestampPagamento,
            TimestampSeparacao,
            TimestampRota,
            TimestampEntregue,
            TimestampCancelado,
            TimestampRetornoStatus,
            TimestampPrevisaoRota,
            ValorCentavosString,
            ValorRealString,
            DataSeparacao,
            HoraSeparacao,
            DataRota,
            HoraRota,
            DataEntregue,
            HoraEntregue,
            DataCancelado,
            HoraCancelado,
            MotivoCancelamento,
            DataHoraPagamento,
            FiltroStatusPedidoPagamentoCidade,
            FiltroStatusPedidoCidade,
            Dispositivo,
            Plataforma,
            PDFbase64,
            PDFbase64Parcela2,
            ObservacaoBoleto,
            ObservacaoBoleto2,
            IDBoleto,
            IDBoleto2,
            ...pedido
          } = pedidoOriginal;

          this.pedidos.push(pedido);

          this.valorTotalPedidos += pedido.Total;

          if (pedido.StatusPagamento === 'Pendente') {
            this.valorTotalPagamentosPendentes += pedido.Total;
          }
        }
      });
      this.spinner.hide('relatorio-pagamentos');
    });
  }

  validarFiltro(tipoPagamento, statusPagamento, pedido: PedidoConsultaElement): boolean {
    if (tipoPagamento !== 'Todos' && pedido.FormaPagamento !== tipoPagamento) {
      return false;
    }

    if (statusPagamento !== 'Todos' && pedido.StatusPagamento !== statusPagamento) {
      return false;
    }

    return true;
  }

  exportar() {
    this.excelService.exportAsExcelFile(this.pedidos, `relatorio_pagamentos_${this.usuarioService.tratarData(new Date().getTime())}`);
  }

}